export enum EventType {
  AppInstallEvent = 'AppInstallEvent',
  NewContentPromoteEvent = 'NewContentPromoteEvent',
  NormalEvent = 'NormalEvent',
  PromotionEvent = 'PromotionEvent',
}

export const EventTypeString = {
  [EventType.AppInstallEvent]: '앱 설치 이벤트',
  [EventType.NewContentPromoteEvent]: '작품 감상 이벤트',
  [EventType.NormalEvent]: '일반 이벤트',
  [EventType.PromotionEvent]: '프로모션 이벤트',
};

export enum EventListType {
  Progress = 'Progress',
  Finish = 'Finish',
}

export enum EventProgressType {
  BeforeTheStart = 'BeforeTheStart',
  Proceeding = 'Proceeding',
  Ended = 'Ended',
}

export const EventProgressTypeString = {
  [EventProgressType.BeforeTheStart]: '진행 예정',
  [EventProgressType.Proceeding]: '진행 중',
  [EventProgressType.Ended]: '종료됨',
};

export enum EventRaffleType {
  None = 'None',
  Reply = 'Reply',
}

export const EventRaffleTypeString = {
  [EventRaffleType.None]: '없음',
  [EventRaffleType.Reply]: '댓글 정렬 추첨',
};

export enum EventRaffleStatus {
  Waiting = 'Waiting',
  Aggregating = 'Aggregating',
  AggregateFinished = 'AggregateFinished',
  CouponProvided = 'CouponProvided',
}

export enum EventNotiTitleType {
  Purple = 'Purple',
  Red = 'Red',
}
